import { render, staticRenderFns } from "./HappinessSurvey.vue?vue&type=template&id=6b85125b&scoped=true&"
import script from "./HappinessSurvey.vue?vue&type=script&lang=js&"
export * from "./HappinessSurvey.vue?vue&type=script&lang=js&"
import style0 from "./HappinessSurvey.vue?vue&type=style&index=0&id=6b85125b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b85125b",
  null
  
)

export default component.exports